import { useContext, useEffect } from "react";
import { useHistory } from "react-router";

import { UserContext } from "@/contexts/user/UserContext";
import { getPostAuthRoute } from "@/utils/routing/postAuthRoute";

function usePostAuthRedirect(active: boolean): void {
  const { user } = useContext(UserContext);
  const history = useHistory();

  useEffect(() => {
    if (!active || !user) {
      return;
    }

    history.replace(getPostAuthRoute(user));
  }, [active, history, user]);
}

export { usePostAuthRedirect };
